/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { extractErrorFromResponse } from '@revenuewell/front-end-bundle';

export default class BaseApi {
    protected formatApiErrorMessage = (url: RequestInfo, message: string): string => {
        return `Failed to fetch ${url} - ${message}`;
    };

    protected fetchKazooApi = async (url: string, config: any): Promise<any> => {
        try {
            const resp = await fetch(url, config);

            if (!resp.ok) {
                const error = await extractErrorFromResponse(resp);

                switch (resp.status) {
                    case 401:
                        error!.message = this.formatApiErrorMessage(url, 'authentication session is expired.');
                        break;
                    case 403:
                        error!.message = this.formatApiErrorMessage(url, 'operation is forbidden.');
                        break;
                    default:
                        error!.message = this.formatApiErrorMessage(url, 'internal server error.');
                        break;
                }

                return Promise.reject({ ...error });
            }

            const contentType = resp.headers.get('content-type');
            if (contentType && contentType !== 'application/json') {
                if (contentType.indexOf('pdf') > -1 || contentType.indexOf('tiff') > -1) {
                    const fileName =
                        'fax.' + (contentType.indexOf('pdf') > -1 ? 'pdf' : contentType.indexOf('tiff') > -1 ? 'tiff' : '');

                    // download file from blob
                    const blob = await resp.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }

                return;
            }

            return resp.json();
        } catch (error) {
            return Promise.reject({ message: 'internal server error', status: 500 });
        }
    };
}
